import { call, put, takeEvery } from 'redux-saga/effects';
import { ProgramActionKeys, programsActionCreators, UpdateProgramPreSeasonSetup } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { updateProgramPreSeasonSetup } from '../programsApi';
import { IProgramPreSeasonSetup } from '../programsInterfaces';

function* updateProgramPreSeasonSetupSaga(action: UpdateProgramPreSeasonSetup) {
  yield put(uiActionCreators.showSpinnerDialog());

  const response: IApiExecuteRespone<IProgramPreSeasonSetup> = yield call(updateProgramPreSeasonSetup, action.payload);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(programsActionCreators.setPreSeasonSetup([response.value]));
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchUpdateProgramPreSeasonSetup() {
  yield takeEvery(ProgramActionKeys.UPDATE_PROGRAM_PRESEASON_SETUP, updateProgramPreSeasonSetupSaga);
}
